import i18next from 'i18next'
import { Heater } from '../types'

/**
 * Get the name of the heater.
 */
export function getHeaterName(heater: Heater) {
  return (
    heater?.device?.asset?.name ||
    heater?.serialNumber ||
    heater?.customerReference ||
    heater?.catalogProduct?.name ||
    `${i18next.t('heater', { ns: 'heater' })} (${heater.heatingPower}kW)`
  )
}
